import { PortfolioOverviewDashboard } from '@/features/portfolio';

export default PortfolioOverviewDashboard;
